import React from "react";
import Header from "../Components/Header";
import BreadCrumb from "../Components/BreadCrumb";
import FilterPart from "../Layout/FilterPart";
import ProductList from "../Components/ProductList";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";

export default function ProductListing() {
  return (
    <div>
      <Header mode="dark" />
      <BreadCrumb />
      <FilterPart />
      <ProductList />
      <Feature />
      <Footer />
    </div>
  );
}
